import { useFormValidatedValue } from 'modules/taboola-common-frontend-modules/validations';
import { useBudgetValidations } from './useBudgetValidations';

export const useFormBudgetValidatedValue = props => {
    const budgetValidations = useBudgetValidations(props);
    return useFormValidatedValue(budgetValidations);
};
